import {
  Badge,
  Button,
  ComboboxItem,
  Grid,
  Input,
  Text,
  Title,
} from "@mantine/core";
import { modals } from "@mantine/modals";
import { IconSearch, IconUsers } from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import React, { useEffect, useState } from "react";
import {
  _timerDelayClick,
  repositoryPos,
  styleTableMantine,
} from "../../../../_base/_const/_constVar";
import { _localization } from "../../../../config/location";
import { cobalt_blue, green } from "../../../../const/variables";
import {
  getProvinceSelect,
  getTblDmCustomerGroupSelect,
} from "../../../../service/getSelectApi";
import CreateDataView from "../../../CustomerManagement/CustomerList/CreateDataView";
import { CellDoubleClickedEvent } from "ag-grid-community";
import { EmployeeModel } from "../../../../model/Employee";
import { SelectListItemBase } from "../../../../_base/model/_base/SelectListItemBase";
import { MessageResponse } from "../../../../model/MessageResponse";

interface Customer {
  active: boolean;
  address: string;
  attribute1: string | null;
  attribute2: string | null;
  attribute3: string | null;
  attribute4: string | null;
  attribute5: string | null;
  birthOfDate: string; // ISO 8601 Date format
  buyerName: string;
  code: string;
  commune: number;
  communeName: string;
  companyName: string;
  contact: string | null;
  country: string | null;
  debtLimit: number;
  debtTerm: number;
  description: string | null;
  district: number;
  districtName: string;
  email: string;
  fax: string | null;
  groupCode: string;
  groupId: number;
  groupName: string;
  id: number;
  name: string;
  province: number;
  provinceName: string;
  sex: number; // 1: Male, 2: Female, 3: Other
  taxCode: string;
  tblDmCustomerGroupModel: string | null;
  telephoneNumber: string;
  type: number; // Typically 1: Individual, 2: Corporate
}

const ListEmployeebyBranch = ({
  handleListEmployyee,
  params,
}: {
  handleListEmployyee: Function;
  navigate?: any;
  params?: CellDoubleClickedEvent<any>;
  isChooseCongNo?: boolean;
  disible?: boolean;
}) => {
  const [data, setData] = useState<EmployeeModel[]>([]);
  const [dataTemp, setDataTemp] = useState<any[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [customerInfo, setCustomerInfo] = useState<MRT_RowSelectionState>({});
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [deleteViewStatus, setDeleteViewStatus] = useState(false);
  const [timeLeft, setTimeLeft] = useState(60);
  const [isCounting, setIsCounting] = useState(false);
  const [search, setSearch] = useState({
    keySearch: "",
    Phone: "",
    TaxCode: "",
    Code: "",
  });
  const [dataBranch, setDataBranch] = useState<SelectListItemBase[]>([]);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const headerRef = React.useRef<HTMLDivElement>(null);
  const gridSpan = { base: 12, sm: 1.5, md: 1.5, lg: 1.5, xl: 1.5 };
  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "id",
        header: "Id",
      },
      {
        accessorKey: "code",
        header: "Mã nhân viên",
      },
      {
        accessorKey: "fullname",
        header: "Tên nhân viên",
        size: 250,
      },
      {
        accessorKey: "email",
        header: "Email",
        //  enableGrouping: true,
        //   size: 50,
      },
      {
        accessorKey: "departmentName",
        header: "Phòng ban",
        //  enableGrouping: true,
        //   size: 50,
      },
      {
        accessorKey: "roleName",
        header: "Chức vụ",
        //  enableGrouping: true,
        //   size: 50,
      },
      {
        accessorKey: "phoneNumber",
        header: "Điện thoại",
        //  enableGrouping: true,
        //   size: 50,
      },
      //  {
      //    accessorKey: "dateOfBirth",
      //    header: "Ngày sinh",
      //  },
      {
        accessorKey: "address",
        header: "Địa chỉ",
        //  enableGrouping: true,
        //   size: 50,
      },
      {
        accessorKey: "description",
        header: "Ghi chú",
        //  enableGrouping: true,
        //   size: 50,
      },
    ],
    []
  );
  const startCountdown = () => {
    if (!isCounting) {
      setTimeLeft(_timerDelayClick);
      setIsCounting(true);
    }
  };

  const handleChangeSearchValue = (value: string, key: string) => {
    setSearch((prevData) => ({ ...prevData, [key]: value }));
  };

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    const selectedBranch = dataBranch?.find(
      (item) => String(item.value) === String(params?.data.creatorbranch ?? "")
    );

    let url = `?BranchId=${Number(selectedBranch?.value)}&Skip=${
      pagination?.pageIndex * pagination?.pageSize
    }&Take=${pagination.pageSize}`;

    if (search.keySearch) {
      url += `&KeySearch=${search.keySearch}`;
    }
    if (search.Code) {
      url += `&Code=${search.Code}`;
    }
    if (search.TaxCode) {
      url += `&TaxCode=${search.TaxCode}`;
    }
    if (search.Phone) {
      url += `&Phone=${search.Phone}`;
    }

    try {
      const response = await repositoryPos.get(
        `/api/v1/TblDmEmployee/get-list${url}`
      );
      if (response && response.success) {
        let result = response?.data;
        setData(result);
        setDataTemp(result);
        setRowCount(response?.totalCount);
        setSelectIds([]);
        table.resetRowSelection();
      } else {
        setData([]);
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
    }
    startCountdown();
  };

  const fetchDataBranch = async () => {
    const dataApi = await repositoryPos.get<MessageResponse<any>>(
      "/api/v1/TblDmInventory/get-select-branch"
    );

    if (dataApi && dataApi.success) {
      const filteredData = dataApi.data.slice(1);
      setDataBranch(filteredData);
    }
  };

  useEffect(() => {
    fetchDataBranch();
  }, []);

  useEffect(() => {
    if (params?.data.creatorbranch) {
      if (dataBranch.length > 0) {
        fetchData();
      }
    }
  }, [
    params?.data.creatorbranch,
    dataBranch,
    pagination.pageIndex,
    pagination.pageSize,
  ]);

  // useEffect(() => {
  //   fetchData();
  // }, [pagination.pageIndex, pagination.pageSize]);

  const table = useMantineReactTable({
    columns,
    data,
    positionToolbarAlertBanner: "bottom",
    columnFilterDisplayMode: "popover",
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: false,
    // getRowId: (row) => row.id.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["index", "code"],
        right: ["action"],
      },
      columnVisibility: { id: false },
      density: "xs",
      pagination: { pageSize: 50, pageIndex: 0 },
    },
    mantineTableContainerProps: {
      style: { maxHeight: "62.5vh", minHeight: "300px" },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    onPaginationChange: (e) => {
      setPagination(e);
    },
    // manualFiltering: true,
    manualPagination: true,
    // manualSorting: true,
    rowCount,
    // onColumnFiltersChange: setColumnFilters,
    // onGlobalFilterChange: setGlobalFilter,
    // onSortingChange: setSorting,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    state: {
      // columnFilters,
      // globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      //sorting,
      rowSelection,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },

    // mantineTableBodyRowProps: ({ row }) => ({
    //   onClick: row.getToggleSelectedHandler(),
    //   sx: { cursor: "pointer" },
    // }),
    mantineTableBodyRowProps: ({ row }) => ({
      onDoubleClick: () => {
        handleListEmployyee(row.original, params);
        modals.closeAll();
      },
      sx: {
        cursor: "pointer", //you might want to change the cursor too when adding an onClick
      },
    }),
  });

  return (
    <>
      <div
        ref={headerRef}
        style={{
          width: "100%",
          border: "1px solid #dee2e6",
          padding: "10px",
        }}
      >
        <Grid>
          <Grid.Col span={{ base: 12 }}>
            <Grid align="center" gutter={"xs"}>
              <Grid.Col span={gridSpan}>
                <Input
                  flex={1}
                  placeholder="Nhập từ khóa tìm kiếm"
                  type="text"
                  w={"100%"}
                  leftSection={
                    <IconSearch
                      size={"20"}
                      color={cobalt_blue.base}
                    ></IconSearch>
                  }
                  onChange={(e) => {
                    handleChangeSearchValue(e.target.value ?? "", "keySearch");
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      fetchData();
                    }
                  }}
                />
              </Grid.Col>
              <Grid.Col span={gridSpan}>
                <Button
                  leftSection={<IconSearch size={14} />}
                  color="blue"
                  variant="outline"
                  onClick={async () => {
                    await fetchData();
                  }}
                >
                  Tìm kiếm
                </Button>
              </Grid.Col>
            </Grid>
          </Grid.Col>
        </Grid>
      </div>
      <div style={{ marginTop: "10px" }}>
        <MantineReactTable table={table} />
      </div>
    </>
  );
};

export default ListEmployeebyBranch;
